<div class="detail-view">
    <div class="table-responsive" style="height: 500px">
        <ag-grid-angular
            #projectFileGrid
            style="width: 100%; height: 100%"
            class="ag-theme-alpine"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [suppressMenuHide]="true"
            (gridReady)="onProjectFileGridReady($event)"
            [frameworkComponents]="frameworkComponents">
        </ag-grid-angular>
    </div>

    <pto-file-uploader
        [fileRoute]="fileRoute"
        (hasFilesToUpload)="hasFilesToUpload($event)"
        (fileUploadStarted)="fileUploadStarted($event)"
        (fileUploadSuccess)="fileUploadSuccess($event)"
        *ngIf="fileRoute && canUploadProjectFile(currentUser)">
    </pto-file-uploader>
</div>
